<template>
    <div>
        <el-row class="u-mb-15">
            <el-col :xs="24" class="u-text-right">
                <el-button type="primary" size="small" plain icon="el-icon-plus" @click="abrirNova">NOVA ETAPA</el-button>
            </el-col>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th class="hidden-mobile u-text-center" style="width: 70px;">Ordem</th>
                        <th>Nome</th>
                        <th class="hidden-mobile">Curso vinculado</th>
                        <th class="hidden-mobile">Classificação</th>
                        <th class="hidden-mobile">Grupo</th>
                        <th class="hidden-mobile u-text-center" style="width: 120px;">Faixa etária</th>
                        <th class="hidden-mobile u-text-center" style="width: 100px;">Dias letivos</th>
                        <th class="hidden-mobile u-text-center" style="width: 110px;">Situação</th>
                        <th style="width: 150px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody v-if="status">
                    <tr v-for="e in etapas" :key="e.id">
                        <td class="hidden-mobile u-text-center">{{ e.ordem }}</td>
                        <td class="u-uppercase">{{ e.nome }}</td>
                        <td class="hidden-mobile">{{ e.curso ? e.curso.nome : '—' }}</td>
                        <td class="hidden-mobile">{{ e.classificacao || '—' }}</td>
                        <td class="hidden-mobile">{{ e.grupo_classificacao || '—' }}</td>
                        <td class="hidden-mobile u-text-center">{{ faixa(e) }}</td>
                        <td class="hidden-mobile u-text-center">{{ e.qtd_dias_letivos || '—' }}</td>
                        <td class="hidden-mobile u-text-center" style="text-transform: uppercase;">{{ e.situacao === false ? 'Inativo' : 'Ativo' }}</td>
                        <td class="u-text-center acao">
                            <el-button @click="abrirEdicao(e)" title="Editar" type="info" icon="el-icon-edit" size="mini" plain class="u-mr-10"></el-button>
                            <el-button @click="excluir(e)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                        </td>
                    </tr>
                    <tr v-if="!etapas.length">
                        <td colspan="9" class="u-text-center" style="padding: 20px; color: #909399;">
                            Nenhuma etapa cadastrada. Clique em "NOVA ETAPA".
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="!status" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </div>

        <!-- ======================= MODAL DE ETAPA ======================= -->
        <el-dialog :title="edicao.id ? 'EDITAR ETAPA' : 'NOVA ETAPA'" :visible.sync="modalVisivel" width="760px" :close-on-click-modal="false">
            <el-form class="u-mt-20" label-position="top" :model="edicao" ref="edicao" @submit.native.prevent="salvar">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]">
                            <el-input v-model="edicao.nome" maxlength="191" placeholder="Ex.: 1º Ano"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Ordem">
                            <el-input-number v-model="edicao.ordem" :min="0" :step="1" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="8">
                        <el-form-item label="Situação">
                            <el-select v-model="edicao.situacao" style="width: 100%;">
                                <el-option :value="true" label="ATIVO"></el-option>
                                <el-option :value="false" label="INATIVO"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Curso vinculado">
                            <el-select v-model="edicao.curso_id" filterable clearable placeholder="(nenhum)" style="width: 100%;">
                                <el-option v-for="c in init.cursos" :key="c.id" :label="c.nome" :value="c.id"></el-option>
                            </el-select>
                            <div style="color: #909399; font-size: 12px;">
                                É a ponte com a estrutura operacional — turmas e matrículas continuam usando o curso.
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Classificação da etapa">
                            <el-input v-model="edicao.classificacao" maxlength="191" placeholder="Ex.: 1º ano"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Grupo de etapas">
                            <el-input v-model="edicao.grupo_classificacao" maxlength="191" placeholder="Ex.: Anos Iniciais"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="Idade mínima (meses)">
                            <el-input v-mask="'######'" v-model="edicao.idade_minima_meses" placeholder="(não definida)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6">
                        <el-form-item label="Idade máxima (meses)">
                            <el-input v-mask="'######'" v-model="edicao.idade_maxima_meses" placeholder="(não definida)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Dias letivos da etapa">
                            <el-input v-mask="'######'" v-model="edicao.qtd_dias_letivos" placeholder="(usa o da matriz)"></el-input>
                            <div style="color: #909399; font-size: 12px;">Vazio = usa os dias letivos da matriz.</div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <span slot="footer">
                <el-button @click="modalVisivel = false">CANCELAR</el-button>
                <el-button class="u-ml-10" type="primary" @click="salvar">SALVAR</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    props: {
        matrizId: { type: Number, required: true },
        init: { type: Object, required: true }
    },
    data: () => ({
        status: false,
        etapas: [],
        modalVisivel: false,
        edicao: {}
    }),
    mounted () { this.load() },
    methods: {
        msgErro (r) {
            if (!r.data || !r.data.erro) return null
            return typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text
        },
        /** Marcador de protocolo do backend para operações que exigem confirmação. */
        pedeConfirmacao (msg) {
            return !!msg && msg.indexOf('Confirme a operação para prosseguir.') !== -1
        },
        faixa (e) {
            if (e.idade_minima_meses === null && e.idade_maxima_meses === null) return '—'
            const a = e.idade_minima_meses !== null ? e.idade_minima_meses : '?'
            const b = e.idade_maxima_meses !== null ? e.idade_maxima_meses : '?'
            return `${a}–${b} meses`
        },
        vazia () {
            return {
                id: null,
                matriz_curricular_id: this.matrizId,
                nome: '',
                ordem: this.etapas.length + 1,
                curso_id: null,
                classificacao: '',
                grupo_classificacao: '',
                idade_minima_meses: null,
                idade_maxima_meses: null,
                qtd_dias_letivos: null,
                situacao: true
            }
        },
        load () {
            this.status = false
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/etapas/${this.matrizId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.etapas = Array.isArray(r.data) ? r.data : []
                this.status = true
                this.$emit('total', this.etapas.length)
            }).catch(e => this.$store.commit('throwException', e))
        },
        abrirNova () {
            this.edicao = this.vazia()
            this.modalVisivel = true
        },
        abrirEdicao (e) {
            const copia = JSON.parse(JSON.stringify(e))
            delete copia.curso // relação carregada para exibição; não faz parte do payload
            this.edicao = copia
            this.modalVisivel = true
        },
        salvar () {
            this.$refs.edicao.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }

                window.eventBus.$emit('loading', true)
                const url = this.edicao.id
                    ? `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/etapa/update/${this.edicao.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/etapa/store`

                this.$axios.post(url, this.edicao, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)

                    const erro = this.msgErro(r)
                    if (erro) {
                        window.eventBus.$emit('alert', { msg: erro, type: 'warning' })
                        return
                    }

                    this.modalVisivel = false
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })

                    // O backend devolve `aviso` quando a faixa etária diverge do curso.
                    // É informativo e não bloqueia — a etapa já foi gravada.
                    if (r.data && r.data.aviso) {
                        this.$msgbox.alert(r.data.aviso, 'Atenção', { confirmButtonText: 'Entendi', type: 'warning' }).catch(() => {})
                    }

                    this.load()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        excluir (e) {
            this.$msgbox.confirm(`Excluir a etapa "${e.nome}"?`, 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => this.enviarExclusao(e.id, false)).catch(() => {})
        },
        enviarExclusao (id, confirmar) {
            window.eventBus.$emit('loading', true)
            const url = `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/etapa/delete/${id}` + (confirmar ? '?confirmar=1' : '')

            this.$axios.delete(url, this.$store.getters.getHeaderAuth).then(r => {
                window.eventBus.$emit('loading', false)

                const erro = this.msgErro(r)
                if (erro) {
                    if (!confirmar && this.pedeConfirmacao(erro)) {
                        this.$msgbox.confirm(erro, 'Atenção', {
                            confirmButtonText: 'Excluir mesmo assim', cancelButtonText: 'Cancelar', type: 'warning'
                        }).then(() => this.enviarExclusao(id, true)).catch(() => {})
                        return
                    }
                    window.eventBus.$emit('alert', { msg: erro, type: 'warning' })
                    return
                }

                window.eventBus.$emit('alert', { msg: 'Excluído com sucesso.', type: 'success' })
                this.load()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        }
    }
}
</script>
